import { useEffect, useState } from 'react'
import './HeaderDropdownMenu.scoped.sass'

import threadsService from '@/app-domains/threads/threads.service'

import { ReactComponent as ArrowTurnUpLeft } from '@/assets/icons/arrow-turn-up-left.svg'
import { ReactComponent as ArrowTurnDownRight } from '@/assets/icons/arrow-turn-down-right.svg'

import { ReactComponent as OpenedMessageIcon } from '@/assets/icons/opened-message-icon.svg'
import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon-2.svg'
import { ReactComponent as PinMessage } from '@/assets/icons/pinn-icon-2.svg'
import { ReactComponent as ShowOriginal } from '@/assets/icons/show-original-icon.svg'
import { markMessageAsRead } from '@/app-domains/messages/messages.api'
import dropdownService from '@/components/DropdownMenu/dropdown.service'
import WritingModalService from '@/app-domains/messages/writing/WritingModal.service'
import writingService from '@/app-domains/messages/draft/writing.service'
import modalService from '@/services/modal.service'
import OriginalMessagePage from '@/pages/OriginalMessagePage/OriginalMessagePage'

export function HeaderDropdownMenu ({ thread, message, setMessage, event }) {
  const [deleted, setDeleted] = useState(thread.isDeleted)
  const [pinned, setPinned] = useState(thread.isPinned)

  const iconSize = { width: '18px', height: '18px' }
  const openReplyModal = () => {
    writingService.setDraftReplyBaseData(message, thread)
    WritingModalService.openReplyToThread(message, thread)
  }
  const menuOptions = [
    {
      icon: <ArrowTurnUpLeft style={iconSize} />,
      title: 'Reply',
      action: () => {
        openReplyModal()
        dropdownService.close()
      },
      color: 'normal'
    },
    {
      icon: <ArrowTurnDownRight style={iconSize} />,
      title: 'Forward',
      action: () => {
        writingService.setForwardBaseData(message, thread)
        WritingModalService.openForward(message, thread)
        dropdownService.close()
      },
      color: 'normal'
    },
    {
      icon: <PinMessage style={iconSize} />,
      title: !pinned ? 'Pin message' : 'Unpin message',
      action: () => {
        dropdownService.close()
        threadsService.setThreadPinned(message.threadId, !pinned)
        setPinned(!pinned)
      },
      color: 'normal'
    },
    message.unopen && {
      icon: <OpenedMessageIcon style={iconSize} />,
      title: 'Mark as read',
      action: () => {
        dropdownService.close()
        setMessage({ ...message, unopen: false })
        markMessageAsRead(message.id, thread.id)
      }
    },
    {
      icon: <ShowOriginal style={iconSize} />,
      title: 'Show original',
      action: () => {
        dropdownService.close()
        modalService.open(<OriginalMessagePage style='background-color: #FAFAFA' message={message} />, true)
      }
    },
    {
      separator: true
    },
    {
      icon: <TrashIcon style={iconSize} />,
      title: !deleted ? 'Delete' : 'Restore',
      action: () => {
        dropdownService.close()
        threadsService.setThreadDeleted(message.threadId, message, !deleted)
        setDeleted(!deleted)
      },
      color: 'red'
    },
  ].filter(option => option)

  useEffect(() => {
    dropdownService.open(menuOptions, 'left', event)
  }, [])

  return <></>
}
